import { render, staticRenderFns } from "./CollageAccount.vue?vue&type=template&id=0cebee8c&scoped=true&"
import script from "./CollageAccount.vue?vue&type=script&lang=js&"
export * from "./CollageAccount.vue?vue&type=script&lang=js&"
import style0 from "./CollageAccount.vue?vue&type=style&index=0&id=0cebee8c&prod&lang=css&"
import style1 from "./CollageAccount.vue?vue&type=style&index=1&id=0cebee8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cebee8c",
  null
  
)

export default component.exports